import React from 'react'
import { useTranslation } from 'react-i18next'
import { Legend, ResponsiveContainer, Tooltip, BarChart, Bar, XAxis, YAxis } from 'recharts'

const SummaryBarChart = ({ data }) => {
  const { t } = useTranslation()

  return (
    <div style={{ width: "100%", height: "400px" }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width="100%" height="100%"
          data={data}
          maxBarSize={80}
          margin={{ top: 30, right: 30, left: 20, bottom: 20 }}
        >
          <XAxis dataKey="name" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Legend />
          
          <Bar dataKey="-1" stackId="a" name={t("alert_invalid")} fill="#ff9800" />
          <Bar dataKey="1" stackId="a" name={t("alert_acknowledge")} fill="#42a5f5" />
          <Bar dataKey="2" stackId="a" name={t("alert_resolve")} fill="#4caf50" />
          <Bar dataKey="0" stackId="a" name={t("alert_pending")} fill="#ba68c8" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

export default SummaryBarChart
